
import TagManager from "react-gtm-module"

export const registerGoogleAnalyticsEvent = (event) => {

  try {
    TagManager.dataLayer({ dataLayer: event });
  } catch (error) {
    console.error("Error registering google analytics event", error);
  }

}
